import React from 'react';
import { Check, X } from 'lucide-react';
export function ProsConsSection() {
  const pros = ['Spezialisierung auf Close CRM (tiefe Expertise)', 'Persönlicher Support direkt vom Gründer', 'Nachweisbare Ergebnisse (€7M+ generiert)', 'DSGVO-konform mit deutschen Servern', 'KI-gestützte Automatisierung & Priorisierung', 'Schnelle Implementierung ohne lange Wartezeiten', 'Keine versteckten Kosten'];
  const cons = ['Fokus nur auf Close CRM (keine anderen Systeme)', 'Junges Unternehmen (4 Jahre am Markt)', 'Begrenzte Team-Größe im Vergleich zu Konzernen', 'Keine öffentliche Preisgestaltung (nur auf Anfrage)'];
  return <section className="py-12 bg-white" data-id="element-55">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-56">
        <h2 className="text-2xl font-bold text-slate-900 mb-8" data-id="element-57">
          Vor- und Nachteile im Überblick
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-58">
          {/* Pros */}
          <div className="bg-emerald-50/50 rounded-xl border border-emerald-100 p-6 md:p-8" data-id="element-59">
            <h3 className="text-lg font-bold text-emerald-800 mb-6 flex items-center" data-id="element-60">
              <span className="bg-emerald-100 p-1 rounded mr-2" data-id="element-61">
                <Check className="w-5 h-5 text-emerald-600" data-id="element-62" />
              </span>
              Stärken
            </h3>
            <ul className="space-y-4" data-id="element-63">
              {pros.map((pro, idx) => <li key={idx} className="flex items-start" data-id="element-64">
                  <Check className="w-5 h-5 text-emerald-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-65" />
                  <span className="text-slate-700" data-id="element-66">{pro}</span>
                </li>)}
            </ul>
          </div>

          {/* Cons */}
          <div className="bg-red-50/50 rounded-xl border border-red-100 p-6 md:p-8" data-id="element-67">
            <h3 className="text-lg font-bold text-red-800 mb-6 flex items-center" data-id="element-68">
              <span className="bg-red-100 p-1 rounded mr-2" data-id="element-69">
                <X className="w-5 h-5 text-red-600" data-id="element-70" />
              </span>
              Schwächen
            </h3>
            <ul className="space-y-4" data-id="element-71">
              {cons.map((con, idx) => <li key={idx} className="flex items-start" data-id="element-72">
                  <X className="w-5 h-5 text-red-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-73" />
                  <span className="text-slate-700" data-id="element-74">{con}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}